





















import { Component, Prop, Vue } from 'vue-property-decorator'
import { Route } from 'vue-router'
import { ButtonSize, ButtonTheme, ButtonType } from '@/utils/ButtonAttr'
import BaseLoader from '@/components/reusable-components/placeholder/BaseLoader.vue'
import { RawLocation } from 'vue-router/types/router'

const BLOCK_SELECTOR = 'base-button'
@Component({
    components: { BaseLoader },
})
export default class BaseButton extends Vue {
    @Prop({
        type: String,
        default: undefined,
        validator(v) {
            return Object.values(ButtonType).includes(v)
        },
    })
    type!: ButtonType
    @Prop({ type: [String, Object], default: null }) to!: Route | null
    @Prop({ type: String, default: null }) href!: string | null
    @Prop({ type: Object, default: () => ({}) }) attributes!: object
    @Prop({ type: Boolean }) disabled!: boolean
    @Prop({ type: Boolean }) icon!: boolean
    @Prop({ type: Boolean }) pending!: boolean
    @Prop({ type: Boolean }) discret!: boolean
    @Prop({ type: Boolean }) squared!: boolean
    @Prop({ type: Boolean }) block!: boolean
    @Prop({ type: Boolean }) liquid!: boolean
    @Prop({
        type: String,
        default: null,
        validator(v) {
            return Object.values(ButtonTheme).includes(v)
        },
    })
    theme!: ButtonTheme | null
    @Prop({
        type: String,
        default: null,
        validator(v) {
            return Object.values(ButtonSize).includes(v)
        },
    })
    size!: ButtonSize | null

    get isMondrian() {
        return true
    }

    get tag() {
        return this.to ? ButtonType.ROUTER_LINK : this.href ? ButtonType.LINK : ButtonType.BUTTON
    }
    get typeAttr() {
        if (this.type && [ButtonType.BUTTON, ButtonType.SUBMIT].includes(this.type)) {
            return this.type
        }

        // Default to type="button" when href is empty
        if (!this.href && !this.to && !this.type) {
            return ButtonType.BUTTON
        }

        return undefined
    }
    get classList() {
        return [
            BLOCK_SELECTOR,
            this.theme && `${BLOCK_SELECTOR}--${this.theme}`,
            this.size && `${BLOCK_SELECTOR}--${this.size}`,
            {
                [`${BLOCK_SELECTOR}--disabled`]: this.disabled,
                [`${BLOCK_SELECTOR}--default`]: this.theme === null,
                [`${BLOCK_SELECTOR}--icon`]: this.icon,
                [`${BLOCK_SELECTOR}--pending`]: this.pending,
                [`${BLOCK_SELECTOR}--discret`]: this.discret,
                [`${BLOCK_SELECTOR}--squared`]: this.squared,
                [`${BLOCK_SELECTOR}--block`]: this.block,
                [`${BLOCK_SELECTOR}--liquid`]: this.liquid,
            },
        ]
    }
    get boundProps() {
        const href = this.href ? this.href : this.to ? this.$router.resolve(this.to as RawLocation).href : null

        return {
            type: this.typeAttr,
            class: this.classList,
            href,
            to: this.to,
            disabled: this.disabled,
            ...this.attributes,
        }
    }
}
